import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { I18nProvider } from "@/i18n/I18nContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { CookieConsent } from "@/components/CookieConsent";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Direct from "@/pages/Direct";
import Privacy from "@/pages/Privacy";
import EspaceCandidat from "@/pages/EspaceCandidat";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/direct" element={<Direct />} />
              <Route path="/confidentialite" element={<Privacy />} />
              <Route path="/espace-candidat" element={<EspaceCandidat />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            </Routes>
            <CookieConsent />
          </BrowserRouter>
          <Toaster position="top-center" theme="dark" richColors />
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
